import { combineReducers } from 'redux'
import locationReducer from './location'
import employee from './employee'
import manager from './manager'
import tags from './tags'
import campaign from './campaign'
import audit from './audit'
import auth from './auth'
import reports from './reports'
import extraCampaign from './extra-campaign'
import emailRules from './email-rules'
import jobs from './jobs'

export const makeRootReducer = (asyncReducers) => {
  return combineReducers({
    location: locationReducer,
    ...auth,
    ...audit,
    ...tags,
    ...manager,
    ...employee,
    ...campaign,
    ...extraCampaign,
    ...reports,
    ...emailRules,
    ...jobs,
    ...asyncReducers
  })
}

export const injectReducer = (store, { key, reducer }) => {
  if (Object.hasOwnProperty.call(store.asyncReducers, key)) return
  store.asyncReducers[key] = reducer
  store.replaceReducer(makeRootReducer(store.asyncReducers))
}

export default makeRootReducer



// WEBPACK FOOTER //
// ./src/store/reducers.js